import { useTranslation } from "react-i18next";
import defaultContent from "../../../../content/periodsProgressCircle";
import "./PeriodsCircleLegend.scss";
import LeafCircleLoader from "../../../leaf/LeafLoadingSkeleton/LeafCircleLoader/LeafCircleLoader";
import LeafRectangleLoader from "../../../leaf/LeafLoadingSkeleton/LeafRectangleLoader/LeafRectangleLoader";

export const PeriodCircleLegendLoader = () => {
  return (
    <div className="PeriodCircleLegend__loaderContainer">
      <div className="PeriodCircleLegend__loading-legend-row">
        <LeafCircleLoader isLoading height="1.35rem" width="1.35rem" />
        <LeafRectangleLoader isLoading height=".875rem" width="90px" margin="0" />
      </div>
      <div className="PeriodCircleLegend__loading-legend-row">
        <LeafCircleLoader isLoading height="1.35rem" width="1.35rem" />
        <LeafRectangleLoader isLoading height=".875rem" width="90px" margin="0" />
      </div>
      <div className="PeriodCircleLegend__loading-legend-row">
        <LeafCircleLoader isLoading height="1.35rem" width="1.35rem" />
        <LeafRectangleLoader isLoading height=".875rem" width="90px" margin="0" />
      </div>
    </div>
  );
};

export const PeriodCircleLegend = ({ disabled }: { disabled: boolean }) => {
  const { t } = useTranslation(["periodsProgressCircle"]);
  const legendItems = [
    { key: "monthlyTarget", color: "gray" },
    { key: "onTrack", color: "green" },
    { key: "belowTarget", color: "orange" },
  ];

  return (
    <section className={`PeriodCircleLegend__legendGroup ${disabled ? "PeriodCircleLegend--disabled" : ""}`}>
      {legendItems.map(({ key, color }) => {
        return (
          <div key={key} className="PeriodCircleLegend__legend">
            <span
              className={`PeriodCircleLegend__legendDot PeriodCircleLegend__legendDot--${color} ${
                disabled ? `PeriodCircleLegend__legendDot--disabled` : ""
              }`}
            ></span>
            <span className={disabled ? `PeriodCircleLegend--disabled` : ""}>
              {t(key, defaultContent[key] as string)}
            </span>
          </div>
        );
      })}
    </section>
  );
};
